import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import AddSomethingModal, {
  type CloseArgs,
  type OpenArgs,
} from 'donor-elf-web/services/add-something-modal';
import ContactsCache from 'donor-elf-web/services/contacts-cache';

let constModalRootElement: any;

export default class AddContactModalComponent extends Component {
  @service declare addSomethingModal: AddSomethingModal;
  @service declare contactsCache: ContactsCache;

  @tracked showModal = false;
  @tracked fadeInShow = false;
  @tracked openArgs?: OpenArgs;

  get modalRootElement() {
    if (constModalRootElement) {
      return constModalRootElement;
    }
    return (constModalRootElement = document.getElementById(
      'add-contact-modal-root',
    ));
  }

  get addingContact() {
    return this.openArgs?.type === 'contact';
  }

  get addingTask() {
    return this.openArgs?.type === 'task';
  }

  get addingPledge() {
    return this.openArgs?.type === 'pledge';
  }

  get addingCampaign() {
    return this.openArgs?.type === 'campaign';
  }

  get addingCampaignGoal() {
    return this.openArgs?.type === 'campaignGoal';
  }

  get changingParentCampaign() {
    return this.openArgs?.type === 'changeParentCampaign';
  }

  get deletingCampaign() {
    return this.openArgs?.type === 'deleteCampaign';
  }

  get mergingContacts() {
    return this.openArgs?.type === 'mergeContacts';
  }

  closeModal() {
    this.fadeInShow = false;
    setTimeout(() => {
      this.showModal = false;
      document.body.classList.remove('modal-open');
    }, 500);
  }

  handleOpen = (_msg: string, data: OpenArgs) => {
    this.openArgs = data;
    document.body.classList.add('modal-open');
    this.showModal = true;
    setTimeout(() => {
      this.fadeInShow = true;
    });
  };

  handleClose = (_msg: string, _data: CloseArgs) => {
    this.closeModal();
  };

  templateDidInsert = () => {
    // since this component is global, we don't need to record
    // the tokens because we don't need to unsubscribe
    this.addSomethingModal.subscribeToOpen(this.handleOpen);
    this.addSomethingModal.subscribeToClose(this.handleClose);
  };
}
